<script setup lang="ts">
// Sierra's .big: a 44 px mono value (36 on phones) with a muted unit after it.
defineProps<{ value: string | number; unit?: string | undefined }>();
</script>

<template>
  <div class="itc-big">
    <slot>{{ value }}</slot><small v-if="unit">{{ unit }}</small>
  </div>
</template>

<style scoped>
.itc-big {
  font-family: var(--itc-font-mono);
  font-size: 44px;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  line-height: 1;
}
.itc-big small {
  margin-left: 4px;
  color: var(--itc-muted);
  font-size: 15px;
  letter-spacing: 0;
}
@media (max-width: 720px) {
  .itc-big {
    font-size: 36px;
  }
}
</style>
